<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <div class="text__view flex flex-col justify-center text-center">
      <h1 class="font-semibold text-2xl my-5">
        {{ ads_test_first_title_subtitle.title }}
      </h1>
      <p class="leading-6 max-w-5xl mx-auto">
        {{ ads_test_first_title_subtitle.subtitle }}
      </p>
    </div>

    <div v-if="advertisements && advertisements.length">
      <template v-if="['free'].includes(roleUser)">
        <UpgradePlans :text="' 15 ultra-high profitable ad examples'" />
        <AdInfo lock="true" />
      </template>
      <template v-else>
        <AdInfo />
      </template>
    </div>
    <div
      class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
      v-else
    >
      <div>
        <h2 class="text-4xl font-semibold mb-4">
          Looking for Ads to test first 👀
        </h2>
        <p class="mb-10 text-lg">
          We recommend you check the completed library and select the awesome
          ads for you
        </p>
        <router-link to="/" class="flex justify-center">
          <Button class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
            >Go To Ads Library</Button
          >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import AdInfo from "@/components/AdsTestInfo/index";
import Button from "@/components/UI/Button";
import UpgradePlans from "@/components/UpgradePlans";

export default {
  components: { HeaderApp, AdblockTopbar, Button, UpgradePlans, AdInfo },
  setup() {
    const router = useRouter();

    onBeforeMount(async () => {
      store.commit("SET_ADS_TEST_FIRST", 0);

      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });
    const store = useStore();
    const selectedAdTest = computed(() => store.state.selectedAdTest);
    const advertisements = computed(() => store.state.adsTestFirst);
    const ads_test_first_title_subtitle = computed(
      () => store.state.adsToTestFirstTitleSubtitle
    );
    const roleUser = computed(() => store.state.role);

    return {
      advertisements,
      ads_test_first_title_subtitle,
      roleUser,
      selectedAdTest,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
